export default __webpack_public_path__ + "static/media/profilePlaceholder.47b63857.png";